import { render, staticRenderFns } from "./InputTextField.vue?vue&type=template&id=21801b88&scoped=true"
import script from "./InputTextField.vue?vue&type=script&lang=js"
export * from "./InputTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21801b88",
  null
  
)

export default component.exports